import { logout as keycloakLogout } from "@/auth/keycloak"

// Session teardown — chat widgets, analytics identity, the Vuex store — is
// registered globally in src/sessionTeardown.js and runs from clearSession(),
// which every path that ends a session already calls. Doing it here instead
// would cover only this action's two callers and miss the common case of a
// refresh token expiring in an idle tab.
export const logout = async () => {
  await keycloakLogout()
}
